import { BaseButton } from "components/ui/Button";
import { motion } from "motion/react";
import styled from "styled-components";
import { mediaMin } from "utils/theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.reverseColors.primary};
`;

export const ToggleButton = styled(BaseButton)`
  display: flex;
  gap: 8px;
  padding: 12px 16px;

  ${mediaMin("md")} {
    padding: 16px 24px;
  }
`;

export const ToggleInfo = styled.div`
  display: flex;
  gap: 8px;
  flex: 1 1 auto;

  text-align: left;
`;

export const ToggleInfoIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ToggleInfoText = styled.div`
  padding: 2px 0;
`;

export const ToggleIcon = styled.div<{ $isToggled?: boolean }>`
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;

  background: ${(props) => props.theme.colors.secondary}33;
  border-radius: 9999px;

  transition: all ${(props) => props.theme.transitions.simple};

  svg {
    * {
      stroke: currentColor;
      stroke-width: 20px;
    }
  }

  ${(props) =>
    props.$isToggled &&
    `
    transform: rotate(-180deg);
  `}
`;

export const InfoContainer = styled(motion.div)``;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 16px 16px;

  ${mediaMin("md")} {
    padding: 0 24px 24px;
    margin-top: -4px;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;
